import React from 'react';

import withLoad from 'components/hocs/withLoad';
import { getItemFromDictBy, renderValueFromDictBy } from 'helpers/fieldsHelpers';

const FieldValue = ({ fieldId, fieldValue = 'id', fieldName = 'value', options, renderItem }) => fieldId && options ? (
    <span>
        { ((renderItem ? renderItem : renderValueFromDictBy)({
            propName: fieldName,
            item: getItemFromDictBy(fieldValue, fieldId, options)
        })) || ''}
    </span>
) : null;

const LoadField = withLoad(props => {
    const { component:Text = FieldValue } = props;

    return <Text {...props} />;
});

export default function LoadedField (props) {
    return <LoadField {...props} />;
}
